import { Typography, IconButton, Box } from '@mui/material';
import React from 'react'
import { dataConstants } from '../../../../constants';
import { getTabData } from '../../../../helpers';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })
import ShareThis from '../../../_common/ShareThis';
import CollapseCard from '../../CollapseCard';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const { ECO_SECTION_CODES } = dataConstants || {};

const LongTermTrend = ({ data, consData, getChartData, onChangeInfo, handleClick, themes, selectedInfo }) => {

  const consumTrend = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_TREND) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_TREND) : undefined;
  const consumTrendChart = consumTrend && consumTrend.tabData ? getChartData(consumTrend.tabData, getTabData(consData, consumTrend, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  return (
    <>
      {consumTrend &&
        <Box component="div" className="col-md-4" sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box component="div">
            <Box
              className="section"
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 1.4,
                px: 0.5,
              }}
            >
              <Typography component="h4" className="option-title" sx={{ mr: 'auto' }} >
                {consumTrend.section_name}
              </Typography>
              {/* <IconButton aria-label="info" onClick={() => onChangeInfo(consumTrend.section_code)}>
                <InfoRoundedIcon size="small" sx={{ fontSize: '1.2rem', color: 'text.link' }} />
              </IconButton> */}
              <ShareThis
                link={encodeURI(`${process.env.NEXT_PUBLIC_URL}${dataConstants.NAVS.CHART_SHARE}/${consumTrendChart?.code}/${consumTrendChart?.series.map(d => d.yformula).join(';')}/${consumTrend.section_name}`)}
                title={`${consumTrend.section_name}`}
                message={`${consumTrend.section_name}`}
                subject={''}
              />
            </Box>
            {consumTrendChart && consumTrendChart.description && <Box component="div" className="option-desc" sx={{ mb: 2, px: 2 }}><Typography variant="caption" sx={{ color: 'text.description' }} dangerouslySetInnerHTML={{ __html: consumTrendChart.description }} /></Box>}
          </Box>
          <Box component="div">
            <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', pr: 2, minHeight: '12rem' }}>
              <D3Chart
                showChart={true}
                noHeader
                // maxHeight={chartProps.maxHeight}
                scale={1}
                // onClick={code => handleClick(code)}
                chart={{ ...consumTrendChart, id: consumTrend.section_code, tick: 2 }}
                // userName={`@${chart.code.split('@')[1]}`}
                themes={themes}
                type={dataConstants.CHART_STATE.VIEW}
                // axisTextMargin={chartProps.axisTextMargin}
                chartMargin={{ left: 40, bottom: 48 }}
                axisTextMargin={{ y: 96 }}
                // wrapperClass="StockCardImage"
                //showLegend={false}
                showCrosshair
              />
            </Box>
            <CollapseCard
              selectedInfo={selectedInfo}
              section_code={consumTrend?.section_code}
              chart_codes={consumTrendChart}
              handleClick={handleClick}
            />
          </Box>
        </Box>}
    </>
  )
}

export default LongTermTrend
